module.exports = __webpack_public_path__ + "img/g矩形 78@1x.7050740a.png";